module.exports = __webpack_public_path__ + "static/media/versioning.b1d124c0.png";